// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width: 1263px)and (max-width: 2499px){.dropdown-text[data-v-ac8a88de]{display:none}}.language__dropdown .v-select__selection--comma[data-v-ac8a88de]{margin:5px 4px 3px 0;font-weight:700;font-size:16px}.language__dropdown[data-v-ac8a88de]{display:flex;justify-content:center;align-items:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
